$( () => {
    var swiperGallery = new Swiper(".swiper-gallery", {
        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: true,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: ".gallery-next",
            prevEl: ".gallery-prev",
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
        },
    });

    var swiperWithTwo = new Swiper(".swiper-boxes-with-two", {
        slidesPerView: 2,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // autoplay: {
        //     delay: 2500,
        //     disableOnInteraction: false,
        // },
        breakpoints: {
            320 :{
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: ".swiper-pagination",
                    // dynamicBullets: true,
                    type: 'bullets',
                    clickable: true,
                },
            },
            576: {
                slidesPerView: 1,
                spaceBetween: 0,
                // pagination: {
                //     el: ".swiper-pagination",
                //     type: 'bullets',
                //     // dynamicBullets: true,
                //     clickable: true,
                // },
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
            1200: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
        },
    });

    

	
	
	if ($('.swiper-hero').length > 0) {
		const swiperHero = new Swiper(".swiper-hero", {
			slidesPerView: 1,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
			},
			pagination: {
				el: ".pagination-hero",
                // dynamicBullets: true,
				clickable: true,
			},
		});
	}

    var swiperLP = new Swiper(".swiper-landing-page", {
        slidesPerView: 1,
        pagination: {
            el: ".pagination-banner",
            type: 'bullets',
            // dynamicBullets: true,
            clickable: true,
        },
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        // },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // effect: "creative",
        // creativeEffect: {
        //   prev: {
        //     shadow: true,
        //     translate: ["-120%", 0, -500],
        //   },
        //   next: {
        //     shadow: true,
        //     translate: ["120%", 0, -500],
        //   },
        // },
        // autoplay: {
        //     delay: 2500,
        //     disableOnInteraction: false,
        // },
    });

    var swiperVideos = new Swiper(".swiper-videos", {
        slidesPerView: 1,
        pagination: {
            el: ".pagination-videos",
            type: 'bullets',
            // dynamicBullets: true,
            clickable: true,
        },
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        // },
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
        // effect: "creative",
        // creativeEffect: {
        //   prev: {
        //     shadow: true,
        //     translate: ["-120%", 0, -500],
        //   },
        //   next: {
        //     shadow: true,
        //     translate: ["120%", 0, -500],
        //   },
        // },
        // autoplay: {
        //     delay: 2500,
        //     disableOnInteraction: false,
        // },
    });

    var swiperBanner = new Swiper(".swiper-banner", {
        slidesPerView: 1,
        pagination: {
            el: ".pagination-banner",
            // dynamicBullets: true,
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        // effect: "creative",
        // creativeEffect: {
        //   prev: {
        //     shadow: true,
        //     translate: ["-120%", 0, -500],
        //   },
        //   next: {
        //     shadow: true,
        //     translate: ["120%", 0, -500],
        //   },
        // },
        // autoplay: {
        //     delay: 2500,
        //     disableOnInteraction: false,
        // },
    });

    var swiperOverlay = new Swiper(".swiper-overlay", {
        slidesPerView: 1,
        // effect: "fade",
        // pagination: {
        //     el: ".pagination-overlay",
        //     // dynamicBullets: true,
        //     clickable: true,
        // },
        navigation: {
            nextEl: ".overlay-next",
            prevEl: ".overlay-prev",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });

    var swiperTestimonial = new Swiper(".swiper-testimonial", {
        slidesPerView: 1,
        // effect: "fade",
        // pagination: {
        //     el: ".pagination-testimonial",
        //     // dynamicBullets: true,
        //     clickable: true,
        // },
        navigation: {
            nextEl: ".testimonial-next",
            prevEl: ".testimonial-prev",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });

    if ($('.swiper-benefits').length > 0)
	{
		// const swiperBenefitsThumbs = new Swiper('.swiper-benefits--thumbs', {
		// 	watchSlidesProgress: true,
		// 	slidesPerView: 2,
		// 	spaceBetween: 10,

		// 	breakpoints: {
		// 		768: {
		// 			slidesPerView: 3,
		// 			centeredSlides: true,
		// 			initialSlide: 1,
        //             spaceBetween: 15,
		// 		},
		// 		1200: {
		// 			slidesPerView: 5,
		// 		}
		// 	},

		// });
        if ($('.swiper-benefits').length > 0) {
            const swiperBenefits = new Swiper(".swiper-benefits", {
                slidesPerView: 1,
                autoplay: {
                    delay: 35000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    dynamicBullets: true,
                    renderBullet: function (index, className) {
                        // console.log($(this));
                        var title = $(this.$el).find('.swiper-slide').eq(index).attr("data-title");
                        return `<span class=${className}>` + title + '</span>';
                    },
                },
            });
        }
	}
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider.js